import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
const AbouttUs = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
 
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);

 
 
  const fetchcategories=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/kitch');
     console.log(res.data.kitchen_calculator);
     setCategories(res.data.kitchen_calculator);
    }catch(e){
      setError(e.response?.data?.message || 'Save failed');
    }
  }
  
  useEffect(() => {
   fetchcategories();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  


  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">Kitchen query Data</h3>
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                 <th>Name</th>
                  <th>Email</th>
                   <th>Phone</th>
                <th>City</th>
                <th>Home</th>
                <th>Wall</th>
                <th>Feet</th>
                <th>Cabinet</th>
                <th>Finish</th>
                <th>Accessories</th>
              </tr>
            </thead>
            <tbody>
            
                {
                categories.length>0 ?(
                
                categories.map((item, index) => (
                <tr key={item.id}>
               
                  <td>{index +1}</td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>{item.city}</td>
                  <td>{item.home}</td>
                  <td>{item.Wall}</td>
                  <td>{item.feet}</td>
                  <td>{item.cabinet}</td>
                  <td>{item.finish}</td>
                  <td>{Object.entries(JSON.parse(item.accessories)).map(
                   ([key,value],index)=>(
                    <div key={index}>
                      {key}:{value}
                    </div>
                   )
                  )}</td>
                  
                  <td className="text-center">
                   
                  </td>
                </tr>
              ))
                ):(
               <tr>

                <td colSpan="10" className="text-center text-muted">
                  No Company Data Found
                </td>
               </tr>

                )}
            </tbody>

            
           
          </table>
        </div>
      </div>
      
    </>
  );
};
export default AbouttUs;


